<template>

	<div class="card thread-member">
		<router-link :to="'/employee/'+member.slug+'/profile'">
			<div class="card-body">
				<div class="avatar-group">
					<div v-if="member.imageUrl" 
						class="member-image" 
						:style="{backgroundImage: 'url(' + member.imageUrl + ')'}">		
					</div>
					<div v-else class="member-image">
						<i class="fa fa-user-circle"></i>
					</div>
					<last-active-indicator 
						class='active-indicator'
						:last-active-utc="member.last_active" 
						:user-id="member.id">
					</last-active-indicator>
				</div>
				<div class="card-content">
					<h5 class="card-title">
						<!--<i v-if="isOnline(member.last_active)" class="fa fa-circle text-success"></i>-->

						{{ member.first_name }} {{ member.last_name }}

						<small v-if="hasReadLatest(member.last_read,lastMessageTime)" class="text-muted">
							Read
						</small>
						<small v-else class="text-muted">
							Unread
						</small>
						
					</h5>
				</div>
			</div>
		</router-link>
	</div>
	
</template>

<script>
import LastActiveIndicator from "@/components/LastActiveIndicator"

export default {
	name: 'ThreadMemberCard',
	components: {
		LastActiveIndicator
	},
	props: ["member","lastMessageTime"],
	methods: {
		hasReadLatest(lastRead, messageTime) {
			if (this.moment(lastRead).isAfter(messageTime))
				return true
			else
				return false
		}
	}

}
</script>

<style type="text/css" scoped>

	.card-body {
		display: -webkit-flex;
		display: flex;
		flex-direction: row;
		padding: 10px;
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.thread-member {
		margin-bottom: 3px;
	}

	.thread-member a {
		text-decoration: none;
		color: inherit;
	}

	.thread-member:hover {
		background-color: #CFD8DC;
		cursor: pointer;
	}

	.avatar-group {
		width: 48px;
		height: 48px;
		position: relative;
		margin-right: 15px;
	}

	.member-image {
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
		border-radius: 50%;
		margin-bottom: -7px;
	}

	.active-indicator {
		position: absolute;
		bottom: 0;
		right: 0;
	}

	.member-image {
		display: inline-block;
		width: 48px;
		height: 48px;
		margin-right: 10px;
	}

	.card-content {
		display: inline-block;
		width: calc(100% - 62px);
		vertical-align: top;
		margin-top: 12px;

	}

	.card-title {
		font-size: 13pt;
	}

	.fa-user-circle {
		font-size: 48px;
	}

	@media (max-width: 500px) {
		.fa-user-circle {
			font-size: 36px;
		}

		.member-image {
			width: 36px;
			height: 36px;
		}

		.card-content {
			margin-top: 7px;
			margin-bottom: -5px;
		}
	}

</style>
